import { motion, HTMLMotionProps } from 'framer-motion';
import { ReactNode } from 'react';
import { useReducedMotion } from '@/lib/motion/hooks/use-reduced-motion';

interface PulseProps extends Omit<HTMLMotionProps<'div'>, 'children'> {
  children: ReactNode;
  /** Scale amount (1.1 = 10% larger) */
  scale?: number;
  /** Animation duration in seconds */
  duration?: number;
  /** Delay before starting */
  delay?: number;
  className?: string;
}

export function Pulse({
  children,
  scale = 1.05,
  duration = 2,
  delay = 0,
  className,
  ...props
}: PulseProps) {
  const reducedMotion = useReducedMotion();

  if (reducedMotion) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      animate={{
        scale: [1, scale, 1],
      }}
      transition={{
        duration,
        repeat: Infinity,
        ease: 'easeInOut',
        delay,
      }}
      className={className}
      {...props}
    >
      {children}
    </motion.div>
  );
}
